import * as React from 'react';
const BadgeCore = (props) => {
    const { className, components, icon, purpose, size, text, } = props;
    const BEM = () => {
        const classArray = ['badge'];
        if (purpose) {
            classArray.push('badge--' + purpose);
        }
        if (size) {
            classArray.push('badge--' + size);
        }
        if (className) {
            classArray.push(className);
        }
        return classArray.join(' ');
    };
    const getIcon = (icon) => {
        const { Icon } = components;
        return React.createElement(Icon, { className: "badge__icon", modifiers: icon });
    };
    const getText = (text) => {
        return React.createElement("span", { className: "badge__text" }, text);
    };
    return (React.createElement("span", { className: BEM(), "aria-hidden": props['aria-hidden'] },
        icon && getIcon(icon),
        text && getText(text)));
};
export { BadgeCore as default, };
